import React from 'react';
import { Lock12 } from 'shared/assets/icons';
import { NavigationCountBadge } from 'shared/components/ui/navigation-count-badge';
import { useTaskCounts } from 'shared/contexts/task-counts';
import { SmartList } from 'shared/types/smart-list';

export type SmartListCountProps = {
  smartList: SmartList;
};

export const SmartListCount: React.FC<SmartListCountProps> = ({
  smartList,
}) => {
  const counts = useTaskCounts();

  if (smartList.frozenAt) {
    return <NavigationCountBadge icon={Lock12} />;
  }

  return (
    <NavigationCountBadge count={counts?.bySmartListId.get(smartList.id)} />
  );
};
